import angular from 'angular';

import termsManagementRouting from './terms-management-routing-module';
import TermsTabModule from './components/terms-tab/terms-tab-module';

import TermsManagementComponent from './terms-management-component';

export default angular
  .module('terms-management', [
    termsManagementRouting.name,
    TermsTabModule.name,
  ])
  .component('cmsTermsOfUseManagement', new TermsManagementComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/terms-management-module.js